import { Body1Stronger, TableCell, TableHeaderCell } from "@fluentui/react-components";
import { useGlobalStatus } from "../../services/GlobalStatusProvider";
import TooltipWatcherWidget from '../TooltipWatcherWidget';
import { formatDisplayDate, getHourTotals } from "../../services/TimeFunctions";

export default function Totals({ timesheetData, leaveData }) {
  const { currentWeekStart, dateToggle } = useGlobalStatus();

  const { 
    weekTotal, 
    dailyTotals 
  } = getHourTotals(timesheetData, leaveData, currentWeekStart);
  
  return (
    <>
    
    <TableHeaderCell style={{fontWeight: "bold" }}>
      <TooltipWatcherWidget text="Total hours for each day across all timecodes and leave" direction="above-start">
      <span>Total</span>
      </TooltipWatcherWidget>
    </TableHeaderCell>
    
      <TableCell style={{backgroundColor: '#eff1f5'}}></TableCell>
    {dailyTotals.map((total, index) => {

        let displayDate = formatDisplayDate(total, dateToggle, true)
          return(
          <TableCell style={{backgroundColor: '#F3F3F3'}} key={index}>
            <div className="table-total-cell">
              <Body1Stronger>{total===0? 0 :displayDate }</Body1Stronger>
            </div>
          </TableCell>
          )  
      })}
    
      <TableCell style={{backgroundColor: '#F3F3F3'}} >
        <TooltipWatcherWidget text="The total hours for the week across all timecodes and leave" direction="below-end">
          <div className="table-total-cell">
            
            <Body1Stronger style={{fontSize: '16px'}}>{weekTotal===0? 0 : formatDisplayDate(weekTotal, dateToggle, true)}</Body1Stronger>
          </div>
        </TooltipWatcherWidget>
      </TableCell>
    </>
  );
}
